const yearsToNow = (date) => {
  const today = new Date();
  const compare = new Date(date);
  let yearsDiff = today.getFullYear() - compare.getFullYear();
  const monthsDiff = today.getMonth() - compare.getMonth();
  if (
    monthsDiff < 0 ||
    (monthsDiff === 0 && today.getDate() < compare.getDate())
  ) {
    yearsDiff--;
  }
  return yearsDiff;
};

export default yearsToNow;
